import { render, staticRenderFns } from "./AltSpinner.vue?vue&type=template&id=62a89175&"
import script from "./AltSpinner.vue?vue&type=script&lang=ts&"
export * from "./AltSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports